import { PriceListFileType } from '../models';
export function getFileExtensionByType(fileType) {
    switch (fileType) {
        case PriceListFileType.Csv: {
            return 'csv';
        }
        case PriceListFileType.Txt: {
            return 'txt';
        }
        case PriceListFileType.Xls: {
            return 'xls';
        }
        case PriceListFileType.Xlsx: {
            return 'xlsx';
        }
        default: {
            throw new Error(`Unhandled 'PriceListFileType' case: ${fileType}`);
        }
    }
}
